import { ModalBackground } from "../hometab/styles";
import { useRef, useState } from "react";
import EditIcon from "../../../assets/images/Edit.svg";
import file from "../../../assets/images/Image File.png";
import wave from "../../../assets/images/waves pattern.svg";
import { ModalCard, Heading, Info, ImageContainer, Image, Edit, Header, HeroImageContainer } from "./styles";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../../../constants";
import Spinner from "../../atoms/spinner";

interface HeroProps {
  toggleClear: () => void;
  refresh: boolean;
  setRefresh: any;
  hero: any;
}

export function HeroModal({ toggleClear, refresh, setRefresh, hero }: HeroProps) {
  const imageHeaderSubmitRef = useRef<any>();
  const imageHeroSubmitRef = useRef<any>();
  const [heroImageloading, setHeroImageloading] = useState(false);
  const [headerImageloading, setHeaderImageloading] = useState(false);
  const heroImageRef = useRef<any>();
  const headerImageRef = useRef<any>();
  let businessUuid = useSelector((state: any) => state.auth.uuid);
  const [headerImageSize, setHeaderImageSize] = useState({
    message: "",
  });
  const [heroImageSize, setHeroImageSize] = useState({
    message: "",
  });
  let [productForm, setProductForm] = useState<any>({});

  const previewHeroImage = (event: any) => {
    event.preventDefault();
    let reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        heroImageRef.current.src = reader.result;
        setProductForm({ ...productForm, heroImage: event.target.files[0] });
        setTimeout(() => {
          imageHeroSubmitRef.current.click();
          setHeroImageloading(true);
        }, 300);
      }
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const previewHeaderImage = (event: any) => {
    event.preventDefault();
    let reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        headerImageRef.current.src = reader.result;
        setProductForm({
          ...productForm,
          headerImage: event.target.files[0],
        });
        setTimeout(() => {
          imageHeaderSubmitRef.current.click();
          setHeaderImageloading(true);
        }, 300);
      }
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleHeaderImage = (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    if (productForm?.headerImage?.name) {
      formData.append("image", productForm.headerImage, productForm.headerImage?.name);
    }

    if (productForm?.headerImage === null) {
      setHeaderImageSize({
        message: "Image required ",
      });
    } else if (productForm?.headerImage?.size >= 5000000) {
      setHeaderImageSize({
        message: "File is too large, Max allowed size is 5MB",
      });
    } else {
      setHeaderImageSize({
        message: "",
      });

      formData.append("businessUuid", businessUuid);
      axios
        .post(`${API_URL}/update/header/image`, formData)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            toast.success(response.data.message);
            setHeaderImageloading(false);
            setProductForm({});
            setRefresh(!refresh);
          }
        })
        .catch((error) => {
          setProductForm({});

          if (error?.response?.status === 400 || error?.response?.status === 401) {
            toast.error(error?.response?.data?.message);
            return;
          }
          toast.error("Connection Failed");
        });
    }
  };

  const handleHeroImage = (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    if (productForm?.heroImage?.name) {
      formData.append("image", productForm.heroImage, productForm.heroImage?.name);
    }
    if (productForm?.heroImage === null) {
      setHeroImageSize({
        message: "Image required ",
      });
    } else if (productForm?.heroImage?.size >= 5000000) {
      setHeroImageSize({
        message: "File is too large, Max allowed size is 5MB",
      });
    } else {
      setHeroImageSize({
        message: "",
      });
    }
    formData.append("businessUuid", businessUuid);
    axios
      .post(`${API_URL}/update/hero/image`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          setHeroImageloading(false);
          setProductForm({});
          setRefresh(!refresh);
        }
      })
      .catch((error) => {
        setProductForm({});

        if (error?.response?.status === 400 || error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <div>
          <Heading>Hero</Heading>
          <Info>Upload an image that would make you stand out</Info>
          <form onSubmit={handleHeroImage}>
            <ImageContainer>
              <Image>
                {heroImageloading && (
                  <div className="absolute top-0 left-0 z-50 w-full h-full bg-gray-900 bg-opacity-50 flex justify-center items-center">
                    <Spinner />
                  </div>
                )}
                <img src={productForm?.image?.imageUrl || hero?.heroImage || file} alt="" ref={heroImageRef} />
              </Image>
              <Edit>
                <img src={EditIcon} alt="" className="cursor-pointer z-[200]" />
                <input
                  className="h-[100%] w-[100%] opacity-0  cursor-pointer absolute top-0 left-0 z-50 "
                  type="file"
                  onChange={previewHeroImage}
                  accept="image/*"
                />
                <input type="submit" value="save image" ref={imageHeroSubmitRef} hidden={true} />
              </Edit>
            </ImageContainer>
          </form>
          {heroImageSize?.message && <p className="text-xs mb-2 text-red-600">{heroImageSize?.message}</p>}

          <Header>Header Image</Header>
          <form onSubmit={handleHeaderImage}>
            <HeroImageContainer>
              {headerImageloading && (
                <div className="absolute top-0 left-0 z-50 w-full h-full bg-gray-900 bg-opacity-50 flex justify-center items-center">
                  <Spinner />
                </div>
              )}
              <img src={productForm?.image?.imageUrl || hero?.headerImage || wave} alt="" ref={headerImageRef} />
              <Edit>
                <img src={EditIcon} alt="" className="cursor-pointer" />
                <input
                  className=" opacity-0  cursor-pointer absolute top-0 left-0 z-0 "
                  type="file"
                  onChange={previewHeaderImage}
                  accept="image/*"
                />
                <input type="submit" value="save image" ref={imageHeaderSubmitRef} hidden={true} />
              </Edit>
            </HeroImageContainer>
            {headerImageSize?.message && <p className="text-xs mb-2 text-red-600">{headerImageSize?.message}</p>}
          </form>
          <div
            onClick={() => {
              toggleClear();
            }}
          ></div>
        </div>
      </ModalCard>
    </ModalBackground>
  );
}
